import { useTranslation } from "next-i18next";

import ButtonOrLink from "components/Button/ButtonOrLink";

export default function CustomerSupportMessage() {
  const { t } = useTranslation("common");

  return (
    <p className="mt-2 text-xs text-white/70">
      {t("customer_support_prefix")}{" "}
      <ButtonOrLink
        href="mailto:help@podspace.com"
        className="rounded text-white underline transition hover:text-white/70 focus:shadow-input-focus focus:outline-none focus:ring-0"
      >
        {t("customer_support")}
      </ButtonOrLink>{" "}
      {t("customer_support_suffix")}{" "}
      <ButtonOrLink
        href="#faq"
        className="rounded text-white underline transition hover:text-white/70 focus:shadow-input-focus focus:outline-none focus:ring-0"
        smoothScroll
      >
        {t("faq")}
      </ButtonOrLink>
      .
    </p>
  );
}
